export default {
	messages: {
		ru: {
			'Від': 'От',
			'Ціна': 'Цена',
			'Вкажіть ціну': 'Укажите цену',
			'Обрати': 'Выбрать',
			'html.buAuto.ot': 'от',
			'html.buAuto.do': 'до',
			'html.buAuto.cena': 'Цена',
		},
		uk: {
			'Від': 'Від',
			'Ціна': 'Ціна',
			'Вкажіть ціну': 'Вкажіть ціну',
			'Обрати': 'Обрати',
			'html.buAuto.ot': 'від',
			'html.buAuto.do': 'до',
			'html.buAuto.cena': 'Ціна',
		},
	}
};
